import { ModuleModel } from '../../module.model.interface';
import { BulletinDescriptor, BulletinState } from '../../bulletin/model/bulletin';
import { ProfileModel } from '../../profile/model/profile.model';

export class BulletinHistoryDescriptor implements ModuleModel {
  public discriminator = 'BulletinHistoryDescriptor';

  public id: string;
  public bulletinId: string;
  public bulletinState: BulletinState;
  public body: string;
  public isPublic: boolean;
  public createdBy?: string;
  public createdOn?: Date;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public profileDetail: ProfileModel;
  public profileFullName: string;
  public bulletinDetail: BulletinDescriptor;
  public organizationTitle: string;
  public formTitle: string;

  constructor(options?: {
    id: string;
    bulletinId: string;
    bulletinState: BulletinState;
    body: string;
    isPublic: boolean;
    createdBy: string;
    createdOn: Date;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.bulletinId = options.bulletinId;
      this.bulletinState = options.bulletinState;
      this.body = options.body;
      this.isPublic = options.isPublic;
      this.createdBy = options.createdBy;
      this.createdOn = options.createdOn;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/bulletin.history/model/bulletin.history.ts